<ng-container *ngIf="!isShopifyBusiness">
	<div class="payment-widget">
		<ng-container [ngSwitch]="cardDisplayStatus">
			<ng-container *ngSwitchCase="'hasCards'" [ngTemplateOutlet]="hasCardsRef"></ng-container>
			<ng-container *ngSwitchCase="'hasNoCard'" [ngTemplateOutlet]="hasNoCardRef"></ng-container>
			<ng-container *ngSwitchDefault>
				<div class="card-body payment-widget-body py-4">
					<ngx-skeleton-loader
						animation="pulse"
						appearance=""
						count="4"
						[theme]="{ height: '14px', 'border-radius': '6px', 'margin-bottom': '14px' }"
					></ngx-skeleton-loader>
				</div>
			</ng-container>
		</ng-container>
	</div>
</ng-container>

<ng-container *ngIf="isShopifyBusiness">
	<div class="card-body">
		<div class="mb-3 mb-4">

			<div class="row">
				<div class="col-lg-6">
					<label [ngClass]="{
									'bg-primary-subtle border-primary': selectedShopifyBilling === 'external',
									'border-primary-subtle': selectedShopifyBilling !== 'external'
									}"
								 class="border rounded d-flex align-items-center p-2 mb-3" role="button">
						<span class="form-check form-check-custom form-check-solid form-check-sm align-items-start mx-2">
							<input (change)="selectShopifyBilling('external')" [checked]="selectedShopifyBilling === 'external'"
										 class="form-check-input" name="shopifyPaymentMethod" type="radio">
            </span>
						<div>
							<p class="mb-2">
								<img alt="shopify" class="img-fluid" src="assets/images/brand/shopify.png" width="20px" />
								Proceed on Shopify <span class="mdi mdi-open-in-new"></span>
							</p>
							<small class="mb-1 d-block">Pay
								<app-amount [amount]="paymentDetails.amount" />
							</small>
						</div>
					</label>
				</div>

				<div class="col-lg-6">
					<label [ngClass]="{
									'bg-primary-subtle border-primary': selectedShopifyBilling === 'credit',
									'bg-secondary-subtle': !shopifyCreditBalance,
									'border-primary-subtle': selectedShopifyBilling !== 'credit' && shopifyCreditBalance
									}"
								 class="border rounded d-flex align-items-center p-2 mb-3" role="button">
						<span class="form-check form-check-custom form-check-solid form-check-sm align-items-start mx-2">
							<input (change)="selectShopifyBilling('credit')" [checked]="selectedShopifyBilling === 'credit'"
										 [disabled]="!shopifyCreditBalance"
										 class="form-check-input" name="shopifyPaymentMethod" type="radio">
            </span>
						<div>
							<p class="mb-2">
								<img alt="shopify" class="img-fluid" src="assets/images/logo-icon.svg" width="20px" />
								AtomicTax Credit Balance:
								<span class="badge badge-pill bg-secondary-subtle text-primary fw-bolder">
									{{ shopifyCreditBalance | number }}
								</span>
							</p>
							@if (shopifyCreditBalance) {
								<small class="mb-1 d-block"> Use 1 credit </small>
							} @else {
								<a class="mb-1 d-block small" href="javascript:void(0)"
									 routerLink="/account-settings/plan/shopify">
									Top-up
								</a>
							}
						</div>
					</label>
				</div>
			</div>

			<button type="button" (click)="emitSelection()" [disabled]="isMakingPayment" class="btn btn-primary w-100 p-3 my-3"
							data-test-id="make-payment-button">
				Pay
				<i *ngIf="isMakingPayment" aria-hidden="true" class="mdi mdi-cisco-webex mdi-spin mx-1"></i>
			</button>
		</div>
	</div>
</ng-container>


<ng-template #hasCardsRef>
	<div class="card-body payment-widget-body">
		<h3 class="h5 fw-semibold mb-1">Payment method</h3>
		<p class="text-muted small mb-4">Select a saved card or use another card for this payment.</p>

		<div class="row g-3">
			<div *ngFor="let paymentMethod of paymentMethods" class="col-lg-6">
				<div *ngIf="paymentMethod.type === 'card'" class="payment-widget-card-wrap h-100">
					<label
							 [ngClass]="{
									'payment-widget-card--selected': selectedCard === paymentMethod,
									}"
							 class="payment-widget-card border rounded-3 d-flex align-items-start gap-3 p-3 mb-0 h-100"
							 role="button">
						<span class="form-check form-check-custom form-check-solid form-check-sm pt-1">
							<input (change)="selectCard(paymentMethod)" [checked]="selectedCard === paymentMethod"
										 [disabled]="freezeAllActions"
										 class="form-check-input mt-0" name="paymentMethod" type="radio">
            </span>
					<span class="flex-grow-1 min-w-0">
							<span class="d-flex align-items-center gap-2 mb-1 flex-wrap">
								<img alt="" class="payment-widget-brand" src="assets/images/brand/{{ paymentMethod.card?.brand?.toLowerCase() }}.svg"
								   (error)="$event.target.src = 'assets/images/brand/card.png'"
								/>
								<span class="fw-semibold text-truncate">{{ paymentMethod.card?.brand | titlecase }}</span>
								<span *ngIf="isDefaultPaymentMethod(paymentMethod)" class="badge text-bg-primary-subtle text-primary">Default</span>
							</span>
							<span class="d-block font-monospace fs-5 lh-sm mb-1">···· {{ paymentMethod.card?.last4 }}</span>
							<span class="text-muted small">Expires {{ paymentMethod.card?.exp_month }}/{{ paymentMethod.card?.exp_year }}</span>
						</span>
					</label>
					<button
						*ngIf="canDeleteCard(paymentMethod)"
						type="button"
						class="btn btn-sm btn-link text-danger payment-widget-remove-card"
						data-test-id="remove-saved-card-button"
						[disabled]="freezeAllActions"
						(click)="deleteCard(paymentMethod, $event)"
					>
						Remove
						<span *ngIf="deletingPaymentMethodId === paymentMethod.id" class="mdi mdi-cisco-webex mdi-spin" aria-hidden="true"></span>
					</button>
				</div>
			</div>

			<div class="col-lg-6">
				<button
					(click)="toggleAddNewCardDisplay()"
					[disabled]="freezeAllActions"
					class="payment-widget-add-card btn btn-outline-primary border-dashed rounded-3 w-100 h-100 py-4 px-3"
					type="button"
					data-test-id="add-new-card-button"
				>
					<span class="mdi mdi-plus-circle-outline mdi-24px d-block mb-2 text-primary" aria-hidden="true"></span>
					<span class="fw-semibold d-block">Use a different card</span>
					<span class="text-muted small d-block mt-1">Debit or credit; saves after checkout where applicable</span>
				</button>
			</div>
		</div>

		<div *ngIf="!selectedCard && displayAddNewCardForm" class="mt-4 pt-4 border-top border-light-subtle">
			<app-new-card-form (cardTokenizeEnd)="handleCardTokenizedEvent($event)"
												 (cardTokenizeError)="handleCardTokenizeErrorEvent()"
												 (cardTokenizeStart)="handleCardTokenizeStartEvent()" />
		</div>
	</div>
</ng-template>

<ng-template #hasNoCardRef>
	<div class="card-body payment-widget-body">
		<div class="d-flex gap-3 mb-4 pb-3 border-bottom border-light-subtle">
			<div class="payment-widget-lock rounded-circle bg-primary-subtle text-primary flex-shrink-0" aria-hidden="true">
				<span class="mdi mdi-lock-outline mdi-28px"></span>
			</div>
			<div>
				<h3 class="h5 fw-semibold mb-2">Add a payment card</h3>
				<p class="text-muted small mb-0">
					We bill registration and filing through Stripe. Enter your card here—nothing is charged until you confirm checkout below.
				</p>
			</div>
		</div>

		<app-new-card-form (cardTokenizeEnd)="handleCardTokenizedEvent($event)"
											 (cardTokenizeError)="handleCardTokenizeErrorEvent()"
											 (cardTokenizeStart)="handleCardTokenizeStartEvent()" />
	</div>
</ng-template>
